import { Type } from 'class-transformer';

export type SortOrder = 'asc' | 'desc';

export class PaginationFilter
{
    public isEnabled = false;
    public forgeFieldName: string = '';
    public matchValue: string = '';
    public isFuzzyMatch = false;

    public static create(isEnabled: boolean, forgeFieldName: string, matchValue: string, fuzzyMatch: boolean)
    {
        let result = new PaginationFilter();
        result.isEnabled = isEnabled;
        result.forgeFieldName = forgeFieldName;
        result.matchValue = matchValue;
        result.isFuzzyMatch = fuzzyMatch;
        return result;
    }
}

export class PaginationRequest
{
    public enablePagination: boolean = false;
    public pageNumber: number = 0;
    public pageSize: number = 15;
    public sortField: string = '';
    public sortOrder: SortOrder = 'asc';

    @Type(() => PaginationFilter)
    public filters: PaginationFilter[] = [];
    
    public static withPageNumber(pageNumber: number)
    {
        let result = new PaginationRequest();
        result.enablePagination = true;
        result.pageNumber = pageNumber;
        return result;
    }
    
    public static noPagination()
    {
        let result = new PaginationRequest();
        result.enablePagination = false;
        return result;
    }

    public addSorting(sortField: string, sortOrder: SortOrder): PaginationRequest
    {
        this.sortField = sortField;
        this.sortOrder = sortOrder;
        return this;
    }

    public addFilter(filter: PaginationFilter): PaginationRequest
    {
        this.filters.push(filter);
        return this;
    }

    public setPageSize(pageSize: number): PaginationRequest
    {
        this.pageSize = pageSize;
        return this;
    }
}

export class PaginationResponse
{
    public paginationEnabled: boolean = false;
    public totalResults: number = 0;
    public pageNumber: number = 0;
    public pageSize: number = 0;
}
